import { create } from "zustand";
import type { UserRole, WorkbenchUser } from "../types";
import { getApi } from "../api";
import { reportError } from "../services/eventBus";

interface SessionState {
  user: WorkbenchUser | null;
  role: UserRole;
  recentGroupIds: readonly string[];
  isLoading: boolean;
  loadError: string | null;
  loadSession: () => Promise<void>;
  setRole: (role: UserRole) => void;
  clear: () => void;
}

export const useSessionStore = create<SessionState>()((set) => ({
  user: null,
  role: "Underwriter",
  recentGroupIds: [],
  isLoading: false,
  loadError: null,

  loadSession: async () => {
    set({ isLoading: true, loadError: null });
    try {
      const current = await getApi().getCurrentUser();
      const { recentGroupIds, ...user } = current;
      set({ user, role: user.role, recentGroupIds, isLoading: false });
    } catch (error) {
      const reported = reportError(error, "sessionStore.loadSession");
      set({ isLoading: false, loadError: reported.message });
    }
  },

  setRole: (role) => set((state) => ({ role, user: state.user ? { ...state.user, role } : state.user })),

  clear: () => set({ user: null, role: "Underwriter", recentGroupIds: [], loadError: null }),
}));
